const formaterOgTitle = (title, config) => {
  return [
    title, config.suffixDivider, config.suffixTitle
  ].filter((t) => !!t).join(" ")
}

export {
  formaterOgTitle
}
